import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import SatelliteTable from '../../../SatelliteTable/SatelliteTable';
import satelliteIcon from '../../../satelliteIcon';

const CostCustomSoftware4 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="costCustomSoftware" section="projectType">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="costCustomSoftware:projectType" first />
            </div>
            <SatelliteTable t={props.t} prefix="costCustomSoftware:projectType.table" columns={['type', 'example', 'investment', 'timeline', 'team']} level="investment" />
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="costCustomSoftware:projectType.after" noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CostCustomSoftware4;
